import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 32 32\" id=\"icon-facebook\"><circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#4267B2\" /><path fill=\"#fff\" d=\"m22.058 21.23.632-4.38h-3.952v-2.84c0-1.198.55-2.367 2.321-2.367h1.798V7.915s-1.631-.296-3.19-.296c-3.256 0-5.382 2.098-5.382 5.894v3.338h-3.619v4.379h3.619v10.587a13.548 13.548 0 0 0 4.453 0V21.23h3.32Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol